var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html, LitElement } from 'lit';
import { property, query, queryAssignedElements } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { SdsInputBase } from '../input/_sds-input-base';
import { appendStylesToTheStyleRoot } from '../utilities/dom';
import stylesGlobal from './sds-input-prefix-suffix-global.lit.scss';
import styles from './sds-input-prefix-suffix.lit.scss';
import { isNil } from 'lodash-es';
let SdsInputPrefixSuffixBase = (() => {
    var _a, _SdsInputPrefixSuffixBase_value_accessor_storage, _SdsInputPrefixSuffixBase_invalid_accessor_storage, _SdsInputPrefixSuffixBase_errorMessage_accessor_storage, _SdsInputPrefixSuffixBase_label_accessor_storage, _SdsInputPrefixSuffixBase__inputs_accessor_storage, _SdsInputPrefixSuffixBase__container_accessor_storage;
    let _classSuper = LitElement;
    let _value_decorators;
    let _value_initializers = [];
    let _value_extraInitializers = [];
    let _invalid_decorators;
    let _invalid_initializers = [];
    let _invalid_extraInitializers = [];
    let _errorMessage_decorators;
    let _errorMessage_initializers = [];
    let _errorMessage_extraInitializers = [];
    let _label_decorators;
    let _label_initializers = [];
    let _label_extraInitializers = [];
    let __inputs_decorators;
    let __inputs_initializers = [];
    let __inputs_extraInitializers = [];
    let __container_decorators;
    let __container_initializers = [];
    let __container_extraInitializers = [];
    return _a = class SdsInputPrefixSuffixBase extends _classSuper {
            constructor() {
                super(...arguments);
                _SdsInputPrefixSuffixBase_value_accessor_storage.set(this, __runInitializers(this, _value_initializers, ''));
                _SdsInputPrefixSuffixBase_invalid_accessor_storage.set(this, (__runInitializers(this, _value_extraInitializers), __runInitializers(this, _invalid_initializers, false)));
                _SdsInputPrefixSuffixBase_errorMessage_accessor_storage.set(this, (__runInitializers(this, _invalid_extraInitializers), __runInitializers(this, _errorMessage_initializers, '')));
                _SdsInputPrefixSuffixBase_label_accessor_storage.set(this, (__runInitializers(this, _errorMessage_extraInitializers), __runInitializers(this, _label_initializers, void 0)));
                this.inputSlotChangeHandler = (__runInitializers(this, _label_extraInitializers), () => {
                    this.updateInputValue();
                    this._inputs[0].addEventListener('focus', this.focusHandler);
                    this._inputs[0].addEventListener('blur', this.blurHandler);
                    this._inputs[0].addEventListener(SdsInputBase.INPUT_EVENT, this.inputHandler);
                });
                this.focusHandler = () => {
                    this._container.classList.add('sds-input-prefix-suffix--focused');
                };
                this.blurHandler = () => {
                    this._container.classList.remove('sds-input-prefix-suffix--focused');
                };
                this.stylesGlobal = stylesGlobal;
                _SdsInputPrefixSuffixBase__inputs_accessor_storage.set(this, __runInitializers(this, __inputs_initializers, void 0));
                _SdsInputPrefixSuffixBase__container_accessor_storage.set(this, (__runInitializers(this, __inputs_extraInitializers), __runInitializers(this, __container_initializers, void 0)));
                this.inputHandler = (__runInitializers(this, __container_extraInitializers), (event) => {
                    this.dispatchInput(event.detail.value.toString());
                });
            }
            /**
             * @deprecated
             * The current value of the input field.
             * This attribute represents the text entered by the user.
             *
             * Defaults to an empty string.
             *
             * @attr {string} value - The current value of the input field.
             */
            get value() { return __classPrivateFieldGet(this, _SdsInputPrefixSuffixBase_value_accessor_storage, "f"); }
            set value(value) { __classPrivateFieldSet(this, _SdsInputPrefixSuffixBase_value_accessor_storage, value, "f"); }
            /**
             * True if this input is invalid.
             * @attr
             */
            get invalid() { return __classPrivateFieldGet(this, _SdsInputPrefixSuffixBase_invalid_accessor_storage, "f"); }
            set invalid(value) { __classPrivateFieldSet(this, _SdsInputPrefixSuffixBase_invalid_accessor_storage, value, "f"); }
            /**
             * Error message.
             * @attr
             */
            get errorMessage() { return __classPrivateFieldGet(this, _SdsInputPrefixSuffixBase_errorMessage_accessor_storage, "f"); }
            set errorMessage(value) { __classPrivateFieldSet(this, _SdsInputPrefixSuffixBase_errorMessage_accessor_storage, value, "f"); }
            /**
             * The label associated with the input field.
             * This attribute provides context and description for the user regarding the input.
             *
             * @attr {string} label - The label for the input field.
             */
            get label() { return __classPrivateFieldGet(this, _SdsInputPrefixSuffixBase_label_accessor_storage, "f"); }
            set label(value) { __classPrivateFieldSet(this, _SdsInputPrefixSuffixBase_label_accessor_storage, value, "f"); }
            get _inputs() { return __classPrivateFieldGet(this, _SdsInputPrefixSuffixBase__inputs_accessor_storage, "f"); }
            set _inputs(value) { __classPrivateFieldSet(this, _SdsInputPrefixSuffixBase__inputs_accessor_storage, value, "f"); }
            get _container() { return __classPrivateFieldGet(this, _SdsInputPrefixSuffixBase__container_accessor_storage, "f"); }
            set _container(value) { __classPrivateFieldSet(this, _SdsInputPrefixSuffixBase__container_accessor_storage, value, "f"); }
            willUpdate(_changedProperties) {
                if (_changedProperties.has('value') && this._inputs[0]) {
                    this.updateInputValue();
                }
            }
            renderLabel() {
                return this.label
                    ? html `
                  <div class="sds-input-prefix-suffix__label" part="sds-input-prefix-suffix-label">
                      <sds-clipped-text basic text="${this.label}"></sds-clipped-text>
                  </div>
              `
                    : html ``;
            }
            addGlobalStyle() {
                appendStylesToTheStyleRoot(this, 'sds-input-prefix-suffix', this.stylesGlobal.cssText);
            }
            getClasses() {
                return classMap({
                    'sds-input-prefix-suffix': true,
                    'sds-input-prefix-suffix--with-label': this.label,
                    'sds-input-prefix-suffix--invalid': this.invalid,
                });
            }
            updateInputValue() {
                if (this._inputs[0] instanceof SdsInputBase) {
                    if (isNil(this._inputs[0].value) || this._inputs[0].value === '') {
                        this._inputs[0].value = this.value;
                    }
                }
            }
            dispatchInput(value) {
                this.dispatchEvent(new CustomEvent(_a.INPUT_EVENT, {
                    detail: {
                        value: value,
                    },
                    bubbles: false,
                }));
            }
        },
        _SdsInputPrefixSuffixBase_value_accessor_storage = new WeakMap(),
        _SdsInputPrefixSuffixBase_invalid_accessor_storage = new WeakMap(),
        _SdsInputPrefixSuffixBase_errorMessage_accessor_storage = new WeakMap(),
        _SdsInputPrefixSuffixBase_label_accessor_storage = new WeakMap(),
        _SdsInputPrefixSuffixBase__inputs_accessor_storage = new WeakMap(),
        _SdsInputPrefixSuffixBase__container_accessor_storage = new WeakMap(),
        (() => {
            var _b;
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
            _value_decorators = [property({ type: String })];
            _invalid_decorators = [property({ type: Boolean })];
            _errorMessage_decorators = [property({ type: String, attribute: 'error-message' })];
            _label_decorators = [property({ type: String, reflect: true })];
            __inputs_decorators = [queryAssignedElements()];
            __container_decorators = [query('#container')];
            __esDecorate(_a, null, _value_decorators, { kind: "accessor", name: "value", static: false, private: false, access: { has: obj => "value" in obj, get: obj => obj.value, set: (obj, value) => { obj.value = value; } }, metadata: _metadata }, _value_initializers, _value_extraInitializers);
            __esDecorate(_a, null, _invalid_decorators, { kind: "accessor", name: "invalid", static: false, private: false, access: { has: obj => "invalid" in obj, get: obj => obj.invalid, set: (obj, value) => { obj.invalid = value; } }, metadata: _metadata }, _invalid_initializers, _invalid_extraInitializers);
            __esDecorate(_a, null, _errorMessage_decorators, { kind: "accessor", name: "errorMessage", static: false, private: false, access: { has: obj => "errorMessage" in obj, get: obj => obj.errorMessage, set: (obj, value) => { obj.errorMessage = value; } }, metadata: _metadata }, _errorMessage_initializers, _errorMessage_extraInitializers);
            __esDecorate(_a, null, _label_decorators, { kind: "accessor", name: "label", static: false, private: false, access: { has: obj => "label" in obj, get: obj => obj.label, set: (obj, value) => { obj.label = value; } }, metadata: _metadata }, _label_initializers, _label_extraInitializers);
            __esDecorate(_a, null, __inputs_decorators, { kind: "accessor", name: "_inputs", static: false, private: false, access: { has: obj => "_inputs" in obj, get: obj => obj._inputs, set: (obj, value) => { obj._inputs = value; } }, metadata: _metadata }, __inputs_initializers, __inputs_extraInitializers);
            __esDecorate(_a, null, __container_decorators, { kind: "accessor", name: "_container", static: false, private: false, access: { has: obj => "_container" in obj, get: obj => obj._container, set: (obj, value) => { obj._container = value; } }, metadata: _metadata }, __container_initializers, __container_extraInitializers);
            if (_metadata) Object.defineProperty(_a, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
        })(),
        _a.INPUT_EVENT = 'sds.input-prefix-suffix.input',
        _a.styles = styles,
        _a;
})();
export { SdsInputPrefixSuffixBase };
